module.exports = __webpack_public_path__ + "static/media/LogicWedge3_3_1.9479ebb7.png";